// 小說新聞 元件
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { formatToDisplay } from '@/common/dateUtils';
import { DEFAULT_IMG } from '@/common/constant';
import Link from 'next/link';
import useIdolInteraction from '../event/shared/useIdolInteraction';

const CATEGORY_MAP = {
    GAME: '遊戲',
    ANIME: '動漫',
    NOVEL: '小説',
    NEWS: '星聞',
    TERM: '專欄',
};

const defaultTheme = {
    blockClass: 'bg-[rgba(0,0,0,0.5)] border-black',
    textClass: 'text-white group-hover:decoration-white',
    cateClass: 'text-black3',
};

const IndexNovelComponent = ({
    news,
    t,
    isDragging,
    type,
    theme = {},
    actId,
    positionName,
}) => {
    const router = useRouter();
    const isEvent = type === 'event';
    const { blockClass, textClass, cateClass } = { ...defaultTheme, ...theme };

    const newsRef = useRef(null);
    const { handleClick } = useIdolInteraction({
        actId,
        position: positionName,
        ref: newsRef,
    });

    // 分類
    const category = isEvent
        ? CATEGORY_MAP?.[news?.category1?.toUpperCase()]
        : t(news?.category1?.toUpperCase());
    // 顯示時間
    const displayTime = formatToDisplay(news?.displayTime);
    // 連結
    const link = `/${news?.category1}/${news?.slug}`;

    const [origin, setOrigin] = useState('');

    useEffect(() => {
        // 確保只在瀏覽器端執行
        if (typeof window !== 'undefined') setOrigin(window.location.origin);
    }, []);

    return (
        <div
            ref={newsRef}
            className={`relative group rounded-[12px] overflow-hidden flex flex-col h-max border
            ${isEvent ? blockClass : 'bg-white border-black1'}`}
        >
            <div className="pb-[12px] flex-shrink-0">
                {/* 圖片 */}
                <div className="img-box w-full overflow-hidden aspect-[29/17]">
                    <Image
                        className="hover-img"
                        width={290}
                        height={170}
                        src={news?.img || DEFAULT_IMG}
                        alt={news?.alt || 'news-image'}
                        formats={['image/webp']}
                    />
                </div>

                {/* 標題 */}
                <h3
                    className={`px-[20px] mt-[14px] text-btn1 hover-text line-clamp-3 min-h-[50px] 
                    ${isEvent ? textClass : 'text-black8 group-hover:decoration-black8'}`}
                >
                    {news?.title}
                </h3>
            </div>

            <div
                className={`between-center text-btn2 relative px-[20px] pb-[12px] ulg:flex-col ulg:flex-grow ulg:items-start ulg:pb-[16px]
                ${isEvent ? cateClass : 'text-vPurple'}`}
            >
                <div className="between-center w-full">
                    {/* 大分類 */}
                    <div className="trans hover:opacity-[.6] relative z-[3]">
                        <a
                            href={`/${news?.category1}`}
                            aria-label="link to news list"
                            className="py-[5px] pr-[10px] user-drag"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (!isDragging) router.push(`/${news?.category1}`);
                            }}
                        >
                            {category}
                        </a>
                    </div>

                    {/* 新聞時間 */}
                    <span>{displayTime}</span>
                </div>
            </div>

            <Link
                href={origin + link}
                title={news?.title}
                aria-label="link to news page"
                target="_blank"
                className="absolute top-0 left-0 w-full h-full z-[1] user-drag"
                onClick={(e) => {
                    if (isDragging) {
                        e.preventDefault();
                        return;
                    }
                    handleClick();
                }}
            />
        </div>
    );
};

export default IndexNovelComponent;
